import {
  SET_LIST_REPORT_PPD
} from '@/stores/constants';

import {
  getListReportPPD1 }
  from '@/services/report';

export default {
  namespaced: true,
  state: {
    reportPPD: [],

  },
  getters: {
    getListReportPPD1: state => state.reportPPD,
  },
  mutations: {
    [SET_LIST_REPORT_PPD](state, payload  ) {
      state.reportPPD = payload;
    },

  },
  actions: {

    async fetchListReportPPD1({commit}, payload){
      try{
        const res = await getListReportPPD1(payload);
        const{data} = res.data;
        // console.log(res)
        commit(SET_LIST_REPORT_PPD, {data});
      } catch(error){
        return error.response.status;
      }
    },


  },
};
